import { Component } from '@angular/core';

import { Data2Service } from '../../common/data2.service';
import { InfoboxService } from '../../common/infobox/infobox.service';

@Component({
	selector: 'app-navigator-import-analiz',
	templateUrl: './navigator-import-analiz.component.html',
	styleUrls: ['./navigator-import-analiz.component.css'],
})
export class NavigatorImportAnalizComponent {
	data = {
		begin: null,
		end: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
	) {}

	submit() {
		this.api.command('/navigatorImportAnaliz', this.data, (result, error) => {
			if (error) {
				return;
			}
			this.data.begin = null;
			this.data.end = null;
		});
	}
}
